import React from 'react';
import { Card, Table } from 'antd';

class QuantRobotStatusDataCard extends React.Component {

    constructor() {
        super();
    }

    render() {
        let columns = this.props.statusData.cols.map((col, index) => {
            return {
                title: col,
                dataIndex: index + '',
                key: index + '',
                render: item => {
                    let dataSplitArray = item.split(' ');
                    if (dataSplitArray.length === 2) {
                        return <span style={{ color: dataSplitArray[1] }}>{dataSplitArray[0]}</span>
                    }
                    return <span>{dataSplitArray[0]}</span>
                }
            }
        });
        let dataSource = this.props.statusData.rows.map(row => {
            let rowData = {};
            row.forEach((data, index) => {
                rowData[index + ''] = data;
            });
            return rowData;
        });
        return (
            <div>
                <Card title="状态信息" bordered={false} >
                    <Table dataSource={dataSource} columns={columns} pagination={false} />
                </Card>
            </div>
        );
    }

}

export default QuantRobotStatusDataCard;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/quant/QuantRobotStatusDataCard.jsx